const onArrowDown =
  (handler) =>
  (e, ...args) => {
    if (e.key === 'ArrowDown') {
      handler(e, ...args);
    }
  };

export default onArrowDown;
